export const resetPasswordStaticData = {
  confirmPasswordText: 'Confirm Password',
  enterNewPasswordText: 'Enter your new password',
  passwordInputText: 'Password',
  passwordInputPlaceholder: 'Enter new password',
  confirmPasswordInputText: 'Confirm Password',
  confirmPasswordInputPlaceholder: 'Re-enter new password',
  confirmPasswordButtonText: 'Confirm Password',
  congratulationText: 'Congratulations!',
  congratulationMessageText:
    'Your password has been changed. Now, you can log in with new password.',
  signInButton: 'Sign In',
  privacyPolicyText: 'Privacy Policy',
  termConditionText: 'Terms & Condition',
  loginImageText: 'Illustration In Progress',
  passwordLength: 'Password must be at least 8 characters long',
  passwordUppercase: 'Password must include at least one uppercase letter',
  passwordSpecial: 'Password must include at least one special character',
  passwordDigit: 'Password must include at least one digit',
  passwordsNotMatch: 'Passwords do not match',
};

export const resetPasswordHindiData = {
  confirmPasswordText: 'पासवर्ड की पुष्टि करें',
  enterNewPasswordText: 'अपना नया पासवर्ड दर्ज करें',
  passwordInputText: 'पासवर्ड',
  passwordInputPlaceholder: 'नया पासवर्ड दर्ज करें',
  confirmPasswordInputText: 'पासवर्ड की पुष्टि करें',
  confirmPasswordInputPlaceholder: 'नया पासवर्ड पुनः दर्ज करें',
  confirmPasswordButtonText: 'पासवर्ड की पुष्टि करें',
  congratulationText: 'बधाई हो!',
  congratulationMessageText:
    'आपका पासवर्ड बदल दिया गया है। अब आप नए पासवर्ड से लॉग इन कर सकते हैं।',
  signInButton: 'साइन इन करें',
  privacyPolicyText: 'गोपनीयता नीति',
  termConditionText: 'नियम और शर्तें',
  loginImageText: 'चित्रण प्रगति पर है',
  passwordLength: 'पासवर्ड कम से कम 8 अक्षर लंबा होना चाहिए',
  passwordUppercase: 'पासवर्ड में कम से कम एक अपरकेस अक्षर शामिल होना चाहिए',
  passwordSpecial: 'पासवर्ड में कम से कम एक विशेष वर्ण शामिल होना चाहिए',
  passwordDigit: 'पासवर्ड में कम से कम एक अंक शामिल होना चाहिए',
  passwordsNotMatch: 'पासवर्ड मेल नहीं खाते',
};

export const resetPasswordArabicData = {
  confirmPasswordText: 'تأكيد كلمة المرور',
  enterNewPasswordText: 'أدخل كلمة المرور الجديدة',
  passwordInputText: 'كلمة المرور',
  passwordInputPlaceholder: 'أدخل كلمة المرور الجديدة',
  confirmPasswordInputText: 'تأكيد كلمة المرور',
  confirmPasswordInputPlaceholder: 'أعد إدخال كلمة المرور الجديدة',
  confirmPasswordButtonText: 'تأكيد كلمة المرور',
  congratulationText: 'تهانينا!',
  congratulationMessageText:
    'تم تغيير كلمة المرور الخاصة بك. يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.',
  signInButton: 'تسجيل الدخول',
  privacyPolicyText: 'سياسة الخصوصية',
  termConditionText: 'الشروط والأحكام',
  loginImageText: 'الرسم التوضيحي قيد التطوير',
  passwordLength: 'يجب أن تكون كلمة المرور مكونة من 8 أحرف على الأقل',
  passwordUppercase: 'يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل',
  passwordSpecial: 'يجب أن تحتوي كلمة المرور على رمز خاص واحد على الأقل',
  passwordDigit: 'يجب أن تحتوي كلمة المرور على رقم واحد على الأقل',
  passwordsNotMatch: 'كلمات المرور غير متطابقة',
};
